import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { Theme, makeStyles } from '@material-ui/core/styles';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

/* istanbul ignore next */
const useStyles = makeStyles((theme: Theme) => ({
	paper: {
		marginRight: '30px',
		position: 'absolute',
		width: 'min-content',
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		outline: 'none',
		justifyItems: 'center',
		textAlign: 'center',
		paddingTop: '24px',
		paddingRight: '24px',
		paddingLeft: '24px',
		paddingBottom: '12px',
		color: '#4B4B4D',
		fontSize: '16px',
		fontWeight: 600,
		letterSpacing: '0.25px',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	button: {
		margin: '10px',
	},
	buttonWrapper: {
		display: 'flex',
		marginTop: '27px',
		justifyContent: 'flex-end',
	},
}));

interface ModalButton {
	text?: string;
	disabled?: boolean;
	show?: boolean;
	handleFn?(): void;
}

interface ModalProps {
	showModal: boolean;
	okButton: ModalButton;
	cancelButton: ModalButton;
}

const okButtonDefaults: ModalButton = {
	text: 'modal.defaults.ok',
	disabled: false,
	show: true,
	handleFn: () => undefined,
};

const cancelButtonDefaults: ModalButton = {
	text: 'modal.defaults.cancel',
	disabled: false,
	show: true,
	handleFn: () => undefined,
};

export const GenericModal: FunctionComponent<ModalProps> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const okButton = {
		...okButtonDefaults,
		...props.okButton,
	};
	const cancelButton = {
		...cancelButtonDefaults,
		...props.cancelButton,
	};

	const handleOk = () => {
		if (okButton.handleFn) {
			okButton.handleFn();
		}
	};

	const handleCancel = () => {
		if (cancelButton.handleFn) {
			cancelButton.handleFn();
		}
	};

	return (
		<Modal open={props.showModal} onClose={handleCancel}>
			<div className={classes.paper}>
				{props.children}
				<div className={classes.buttonWrapper}>
					{cancelButton.show && (
						<Button
							className={classes.button}
							onClick={handleCancel}
							disabled={cancelButton.disabled}
							variant="text"
							color="default"
						>
							{cancelButton.text && t(cancelButton.text)}
						</Button>
					)}
					{okButton.show && (
						<Button
							className={`generic_modal_ok_button ${classes.button}`}
							onClick={handleOk}
							disabled={okButton.disabled}
							variant="text"
							color="primary"
						>
							{okButton.text && t(okButton.text)}
						</Button>
					)}
				</div>
			</div>
		</Modal>
	);
};
